export default __webpack_public_path__ + "static/media/IconDesc_Engine.64.4d15a3bf.png";